import { mixed } from 'yup';
import { HealixGender } from '../../enums';

export const ReferralHealixPatientGenderSchema = mixed<HealixGender>().oneOf(
  Object.values(HealixGender),
  `Patient gender should be one of: ${Object.values(HealixGender).join(', ')}`,
);
